// extracted by mini-css-extract-plugin
export default {"hideArrows":"plain-input-number_hideArrows__YjCA-","placeHolderShimmer":"plain-input-number_placeHolderShimmer__1etNe"};